import { useState } from 'react';
import { Layout } from '../../Layout/Layout';
import { useAppSelector } from '../../../hooks';
import { selectUser } from '../../../containers/Login/LoginSlice';
import { Page } from '../../Page/Page';
import { shouldUseCoreApi } from '../../../utils/features';
import { setItem } from '../../../utils/storage';
import isElectron from 'is-electron';
import { EnvironmentEnum } from '../../../config/region';
import { useNavigate } from 'react-router-dom';
import SettingsItem from '../Settings/SettingsItem';

function DevOptions() {
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);

  const [useCoreApi, setUseCoreApi] = useState<boolean>(shouldUseCoreApi());

  const coreApiCb = (enabledPrev: boolean) => {
    const enabled = !enabledPrev;
    setUseCoreApi(enabled);
    setItem('useCoreApi', enabled);
  };

  const mayUseCoreApi = (): boolean => {
    if (isElectron()) {
      return false;
    }
    const email = user?.email || '';
    const environment = process.env.REACT_APP_ENV_NAME as EnvironmentEnum;
    const allowedCoreApiEnvs = [EnvironmentEnum.DEV];
    if (window.location.host.includes('localhost') || allowedCoreApiEnvs.includes(environment)) {
      return (
        email.endsWith('@example.com') ||
        email.endsWith('@cosafe.com') ||
        email.endsWith('@openid.example.com')
      );
    }
    return false;
  };

  if (!mayUseCoreApi()) {
    navigate('/sidebar');
  }

  return (
    <Layout isMessageLayout message="Dev Options" to="/sidebar" showBottomTabs>
      <Page>
        <SettingsItem
          visible={true}
          name={'Use Core API'}
          id={0}
          checked={useCoreApi}
          key={'use-core-api'}
          callback={coreApiCb}
        />
      </Page>
    </Layout>
  );
}

export default DevOptions;
